@if (isEnabled) {
  <div class="fixed bottom-20 lg:bottom-6 right-4 sm:right-6 z-50 transition-all duration-300">
    <a
      [href]="whatsAppLink"
      target="_blank"
      rel="noopener noreferrer"
      class="group font-bold rounded-full px-4 py-2.5 sm:px-5 sm:py-3 gap-2.5 hover:scale-105 active:scale-95 transition-all duration-200 flex items-center shadow-xl hover:shadow-2xl shadow-emerald-600/30 text-white border border-white/20 cursor-pointer"
      [ngClass]="theme === 'warm' ? 'bg-emerald-700 hover:bg-emerald-600' : (theme === 'bold' ? 'bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-extrabold' : 'bg-[#25D366] hover:bg-[#20ba59]')"
      [title]="buttonText"
    >
      <i class="fa-brands fa-whatsapp text-xl sm:text-2xl transition-transform group-hover:scale-110"></i>
      <span class="text-xs sm:text-sm font-semibold tracking-wide whitespace-nowrap">{{ buttonText }}</span>
    </a>
  </div>
}
